export const MODULES = {
  DASHBOARD: "Dashboard",
  USERS: "Users",
  STUDENTS: "Students",
  TEACHERS: "Teachers",
  REMOTE: "Remote",
   HOME: "Home"
};



export const PATH_TO_MODULE = {
  dashboard: MODULES.DASHBOARD,
  users: MODULES.USERS,
  students: MODULES.STUDENTS,
  teachers: MODULES.TEACHERS,
  remote: MODULES.REMOTE,
  home: MODULES.HOME
};
